//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";
import { getCookie, toastObj } from "../../../../functions/Functions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const getPIRef = async (branch_id, supplier_id) => {
  //setLoading(true);
  const url = BASE_URL + "/settings/get-available-purchase-invoice/" + branch_id +
    "/" + supplier_id;
  try {
    const res = await axios.get(url, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    });
    if(res.data && Array.isArray(res.data)){
      return res.data;
    }
    return null
  } catch (error) {
    if (error.response?.data?.status === 0) {
      toast.error(`${error.response.data.message}`, toastObj);
    }
  }
};
